import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { AnalyticProvider } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { useTitle } from '@application/use_title';
import { Flex } from '@cellula/react';
import { TopBar } from '@component/top_bar.component';
import { Skeleton } from '@view/view_booking/components/skeleton';
import { ViewBookingRoutes } from '@view/view_booking/components/view_booking_routes';
import { useResolve } from '@visiba/instantiation';
import { useBooking } from '../hooks/use_booking';
import { useBookingBasket } from '../hooks/use_booking_basket';
import { ScreenError } from '../screens/screen_error';

export const ViewBookingLayout = () => {
	const viewBooking = useBooking();
	const analyticService = useResolve(AnalyticService);
	const bookingBasket = useBookingBasket();
	const basket = bookingBasket.getBasket();
	const isRescheduling = !!basket.rescheduleTicket;
	const title = isRescheduling
		? withTranslation('Appointment.AppointmentInfo.Rebooking.Confirm.Title')
		: withTranslation('View.Booking.Title');

	useTitle(title);

	async function handleAbort() {
		analyticService.trackEvent(AnalyticCategories.Booking, 'Clicked', 'Abort button');

		await viewBooking.abortBooking();
	}

	const renderContent = () => {
		if (viewBooking.flowData.status === 'pending') {
			return <Skeleton />;
		}
		if (viewBooking.flowData.status === 'error') {
			return <ScreenError />;
		}
		return <ViewBookingRoutes />;
	};

	return (
		<AnalyticProvider category={AnalyticCategories.Booking}>
			<Flex grow='1'>
				<TopBar.Content title={title} onAbort={handleAbort} />

				{renderContent()}
			</Flex>
		</AnalyticProvider>
	);
};
